/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleUrlInspectionRowData
 */
export interface GoogleSearchConsoleUrlInspectionRowData {
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    inspectionUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    inspectedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    inspectionResultLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    verdict?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    coverageState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    robotsTxtState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    indexingState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    lastCrawlTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    pageFetchState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    googleCanonical?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    userCanonical?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    crawledAs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    richResultsVerdict?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof GoogleSearchConsoleUrlInspectionRowData
     */
    richResultIssues?: Array<object>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleUrlInspectionRowData interface.
 */
export function instanceOfGoogleSearchConsoleUrlInspectionRowData(value: object): value is GoogleSearchConsoleUrlInspectionRowData {
    return true;
}

export function GoogleSearchConsoleUrlInspectionRowDataFromJSON(json: any): GoogleSearchConsoleUrlInspectionRowData {
    return GoogleSearchConsoleUrlInspectionRowDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleUrlInspectionRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleUrlInspectionRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'inspectionUrl': json['inspectionUrl'] == null ? undefined : json['inspectionUrl'],
        'inspectedAt': json['inspectedAt'] == null ? undefined : (new Date(json['inspectedAt'])),
        'inspectionResultLink': json['inspectionResultLink'] === undefined ? undefined : json['inspectionResultLink'] === null ? null : json['inspectionResultLink'],
        'verdict': json['verdict'] === undefined ? undefined : json['verdict'] === null ? null : json['verdict'],
        'coverageState': json['coverageState'] === undefined ? undefined : json['coverageState'] === null ? null : json['coverageState'],
        'robotsTxtState': json['robotsTxtState'] === undefined ? undefined : json['robotsTxtState'] === null ? null : json['robotsTxtState'],
        'indexingState': json['indexingState'] === undefined ? undefined : json['indexingState'] === null ? null : json['indexingState'],
        'lastCrawlTime': json['lastCrawlTime'] === undefined ? undefined : json['lastCrawlTime'] === null ? null : json['lastCrawlTime'],
        'pageFetchState': json['pageFetchState'] === undefined ? undefined : json['pageFetchState'] === null ? null : json['pageFetchState'],
        'googleCanonical': json['googleCanonical'] === undefined ? undefined : json['googleCanonical'] === null ? null : json['googleCanonical'],
        'userCanonical': json['userCanonical'] === undefined ? undefined : json['userCanonical'] === null ? null : json['userCanonical'],
        'crawledAs': json['crawledAs'] === undefined ? undefined : json['crawledAs'] === null ? null : json['crawledAs'],
        'richResultsVerdict': json['richResultsVerdict'] === undefined ? undefined : json['richResultsVerdict'] === null ? null : json['richResultsVerdict'],
        'richResultIssues': json['richResultIssues'] == null ? undefined : json['richResultIssues'],
    };
}

export function GoogleSearchConsoleUrlInspectionRowDataToJSON(json: any): GoogleSearchConsoleUrlInspectionRowData {
    return GoogleSearchConsoleUrlInspectionRowDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleUrlInspectionRowDataToJSONTyped(value?: GoogleSearchConsoleUrlInspectionRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'inspectionUrl': value['inspectionUrl'],
        'inspectedAt': value['inspectedAt'] == null ? value['inspectedAt'] : value['inspectedAt'].toISOString(),
        'inspectionResultLink': value['inspectionResultLink'],
        'verdict': value['verdict'],
        'coverageState': value['coverageState'],
        'robotsTxtState': value['robotsTxtState'],
        'indexingState': value['indexingState'],
        'lastCrawlTime': value['lastCrawlTime'],
        'pageFetchState': value['pageFetchState'],
        'googleCanonical': value['googleCanonical'],
        'userCanonical': value['userCanonical'],
        'crawledAs': value['crawledAs'],
        'richResultsVerdict': value['richResultsVerdict'],
        'richResultIssues': value['richResultIssues'],
    };
}

